var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWithdrawMoney = function SvgWithdrawMoney(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bitmap Copy 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-761.000000, -260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bitmap-Copy-11",
    transform: "translate(760.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFF0E0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)",
    id: "attach_money-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.48,10.9 C10.21,10.31 9.48,9.7 9.48,8.75 C9.48,7.66 10.49,6.9 12.18,6.9 C13.96,6.9 14.62,7.75 14.68,9 L16.89,9 C16.82,7.28 15.77,5.7 13.68,5.19 L13.68,3 L10.68,3 L10.68,5.16 C8.74,5.58 7.18,6.84 7.18,8.77 C7.18,11.08 9.09,12.23 11.88,12.9 C14.38,13.5 14.88,14.38 14.88,15.31 C14.88,16 14.39,17.1 12.18,17.1 C10.12,17.1 9.31,16.18 9.2,15 L7,15 C7.12,17.19 8.76,18.42 10.68,18.83 L10.68,21 L13.68,21 L13.68,18.85 C15.63,18.48 17.18,17.35 17.18,15.3 C17.18,12.46 14.75,11.49 12.48,10.9 Z",
    id: "Path",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWithdrawMoney);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/withdraw-money.088a959dade82f3739711a48f10580d1.svg";